/** store */
import CmsStore from "../components/cms/src/CmsStore";
import BannerStore from "./banners/src/BannerStore";
import { UserStore, AUTHORIZED_USER } from "./user/src/UserStore";
import CompanyStore from "./company/src/CompanyStore";
import CategoriesStore from "./categories/src/CategoriesStore";
import SearchStore from "../components/products/src/search/SearchStore";
import BrandStore from "./brands-carousel/src/BrandStore";
import BasketStore from "./basket/src/BasketStore";
import OrderStore from "./order/src/OrderStore";
import OfferStore from "../components/offer/src/OfferStore";

export function Store() {
  return {
    banner: BannerStore,
    cms: CmsStore,
    user: UserStore,
    company: CompanyStore,
    categories: CategoriesStore,
    search: SearchStore,
    basket: BasketStore,
    brands: BrandStore,
    order: OrderStore,
    offer: OfferStore
  };
}

/** router */

import UserRouter from "./user/src/Router";
import CompanyRouter from "./company/src/Router";
import AccountRouter from "./account/src/account/Router";
import PageRouter from "../components/cms/src/Router";
import BasketRouter from "./basket/src/Router";
import OrderRouter from "./order/src/Router";
import OfferRouter from "../components/offer/src/Router";

export function ComponentsRouter() {
  return [
    ...UserRouter.routers(),
    ...AccountRouter.routers(),
    ...PageRouter.routers(),
    ...BasketRouter.routers(),
    ...CompanyRouter.routers(),
    ...OrderRouter.routers(),
    ...OfferRouter.routers()
  ];
}

export let USER_AUTHORIZED_USER = AUTHORIZED_USER;

export { default as ApiClient } from "../components/api/src/ApiClient";

export { default as SingInPage } from "./user/src/SignPage.vue";
export { default as Cms } from "../components/cms/src/Cms";
export { default as Page } from "../components/cms/src/Page.vue";

export { default as BannerOpacity } from "./banners/src/BannerOpacity.vue";
export { default as Tabs } from "../components/products/src/productPage/elements/Tabs.vue";
export { default as ContactForm } from "../components/company/src/ContactForm.vue";



// WEBPACK FOOTER //
// ./src/components/RedbayComponents.js